import { Route, Routes } from "react-router-dom";
import "./App.css";
import Footer from "./components/footer";
import Navbar from "./components/navbar";
import About from "./pages/about";
import Contact from "./pages/contact";
import Details from "./pages/details";
import Home from "./pages/home";
import ProjectDetail from "./pages/ProjectDetails";
import NotFound from "./pages/Notfound";
import ScrollToTop from "./components/scrollToTop";
import { useEffect } from "react";

function App() {

useEffect(() => {
    const trackVisit = async () => {
      const today = new Date().toLocaleDateString('en-CA');
      const lastVisit = localStorage.getItem('lastVisitDate');

      if (lastVisit === today) {
        return;
      }

      try {
        const response = await fetch("https://azglass.vercel.app/track-visit", {
          method: 'GET',
        });

        if (response.ok) {
          localStorage.setItem('lastVisitDate', today);
        } else {
          console.error('Track visit request başarısız.');
        }
      } catch (err) {
        console.error('Track visit error:', err);
      }
    };

    trackVisit();
  }, []);
  return (
    <>
      <Navbar />

      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/notfound" element={<NotFound />} />
        {/* Details səhifəsi */}
        <Route path="/details/:slug" element={<Details />} />
        {/* Əgər ProjectDetail ayrıca istifadə olunacaqsa */}
        <Route path="/project/:id" element={<ProjectDetail />} />
        <Route path="/blog/:id" element={<ProjectDetail />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
